import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemEnumEditor from '../FormItemEnumEditor';
import FormItemEnumEditorForDataGrid from '../FormItemEnumEditorForDataGrid';
import FormItemEnumRender from '../renders/FormItemEnumRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';
import FormItemEnumRadioEditor from '../FormItemEnumRadioEditor';

export default class FormItemEnumEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemEnumEditorControl";	
		this.module = module;	
	}

	getProperty_NotNull()
	{
		return false;
	}

	validateNotNull()
	{
		var _dataField = this.getDataField();
		if(_dataField && this.group && this.group.currentRecord)
		{
			var value:* = this.group.currentRecord[_dataField];
			if(!value || value == "" || value == "0" || value == 0)
			{
				var _label = this.getProperty_Label();
				var _dataProvider = this.getProperty_DataProvider();
				if(_dataProvider.length>0)
				{
					for(var i = 0;i<_dataProvider.length;i++)
					{
						var item = _dataProvider[i];
						if(item.value == 0 || item.value == "0")
						{
							var _firstValue = item.label;
							break;
						}
					}
				}
				return _label+" 不能为"+((!_firstValue || _firstValue=="")?"空":_firstValue);
			}
		}
		return null;
	}
	
	getDefaultDisplayLength()
	{
		return 10;
	}

	getProperty_DataProvider()
	{
		return this.properties.DataProvider;
	}
	getProperty_Regular()
	{
		return this.properties.Regular;
	}

	getDefaultValue()
	{
		var dvalue = super.getDefaultValue();
		if(dvalue == "")
		{
			dvalue = "0";		
		}
		return dvalue;
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let displayLengthWidth = this.getDisplayLengthWidth();
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let commonProps = this.getCommonProps();
		let displayLength=this.propertyDisplayLength?this.propertyDisplayLength:this.getProperty_DisplayLength();
		let notNull=this.propertyNotNull?this.propertyNotNull:this.getProperty_NotNull();
		let _initRecord = this.record;
		if(!_initRecord)
		{
		  	if(!this.group)
		  	{
		  		let defaultValue = this.getDefaultValue();
		  		_initRecord = defaultValue;
		  	}
		}
		let _multiple = false;
		if(this.isUnderQueryGroup())_multiple = true;
		let isWorkFlow = false;
		let enumType = this.getProperty_EnumType();
		if(this.module && this.module.classAlias == "FormModule")
		{
			if(this.module.getIsWorkFlow() == true)
				isWorkFlow = true;
		}
		if(isWorkFlow == true && enumType == 'Radio')
		{
			this.component = <FormItemEnumRadioEditor displayLengthWidth={displayLengthWidth} key={this.xml.id} 
                xml={this.xml} parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias}
                displayLength={displayLength} notNull={notNull} moduleInstanceId={this.module.instanceUUId}
                dataField = {this.getDataField()} initRecord = {_initRecord} options={this.getProperty_DataProvider()}
                label={label} customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                contextMenuData={this.contextMenuData} formType={EditorFormType.FormModule} multiple={_multiple}
                control={this} underQueryGroup={this.isUnderQueryGroup()} {...commonProps}/>;
		}
		else
		{
			let displayStyle = this.getProperty_DisplayStyle();
			this.component = <FormItemEnumEditor displayLengthWidth={displayLengthWidth} key={this.xml.id} 
                xml={this.xml} parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias}
                displayLength={displayLength} notNull={notNull} moduleInstanceId={this.module.instanceUUId}
                dataField = {this.getDataField()} initRecord = {_initRecord} options={this.getProperty_DataProvider()}
                label={label} regular={this.getProperty_Regular()}  customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                contextMenuData={this.contextMenuData} formType={EditorFormType.FormModule} multiple={_multiple}
                control={this} underQueryGroup={this.isUnderQueryGroup()} {...commonProps}
				cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle}/>;
		}
		return this.component;
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		return <FormItemEnumEditorForDataGrid key={this.xml.id} xml={this.xml} forLookup={forLookup} group={this.group}
				options={this.getProperty_DataProvider()} formType={EditorFormType.FormModule} control={this} regular={this.getProperty_Regular()} 
				verticalAlign={this.getProperty_VAlignment()} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML}/>;
	}

	getRenderForDataGrid(forLookup)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemEnumRender contextMenuData={this.contextMenuData} group={this.group} options={this.getProperty_DataProvider()} dataField = {this.getDataField()}
								formId={this.formId} regular={this.getProperty_Regular()}  menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={forLookup}
								moduleInstanceId={this.module.instanceUUId} verticalAlign={this.getProperty_VAlignment()}  cssStyle={this.getProperty_CSSStyle_Display()}
								displayStyle={displayStyle}/>;
	}

	getRenderForDynamicColumn(dataField)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemEnumRender contextMenuData={this.contextMenuData} group={this.group} options={this.getProperty_DataProvider()} dataField = {dataField}
								formId={this.formId} regular={this.getProperty_Regular()}  menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={false}
								moduleInstanceId={this.module.instanceUUId} verticalAlign={this.getProperty_VAlignment()}  cssStyle={this.getProperty_CSSStyle_Display()}
								displayStyle={displayStyle}/>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemEnumEditorControl.js